// tslint:disable:component-selector
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import * as Library from '../../../../core/library/index';

@Component({
  selector: 'rti-html',
  templateUrl: './rti-html.html',
  styleUrls: ['./rti-html.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RtiHtml {
  @Input() hidden: boolean;
  @Input() disabled: boolean;
  @Input() value: string;
  @Input() class: string;
  // tslint:disable-next-line
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  // added to solve build error
  style = '';

  public OnClick($event) {
    if (Library.isDefined($event)) {
      if (Library.isDefined(this.OnClick)) {
        this.onClick.emit($event);
      }
    }
  }

  constructor() {
    this.value = '';
    this.class = '';
  }
}
